const tap = (fn) => (p) => p.then(fn);

export default tap;
